export default __webpack_public_path__ + "static/media/open_fail.de388835.svg";